import { render } from "./evform.vue?vue&type=template&id=0b41b142&scoped=true"
import script from "./evform.vue?vue&type=script&lang=js"
export * from "./evform.vue?vue&type=script&lang=js"

import "./evform.vue?vue&type=style&index=0&id=0b41b142&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0b41b142"

export default script